import React from 'react';
import Observable from './Observer';


interface Props {
  isLoading: boolean;
  loadMore: () => void;
  threshold: number;
  loader: React.ReactNode;
}

function IoElement({
  isLoading,
  loadMore,
  threshold,
  loader,
}: Props) {
  if (__SERVER__) {
    return null;
  }

  if (isLoading) {
    if (loader) {
      return (
        <>
          {
            loader
          }
        </>
      );
    }

    // TODO: MSR-1499 Create a generic CSS Loader
    return (
      <></>
    );
  }


  return (
    <Observable
      loadMore={loadMore}
      threshold={threshold}
    />
  );
}

export default IoElement;
